export default "__VITE_ASSET__CZ1qZK0K__"